import React from "react";
import { Link } from "react-router-dom";
import media from "../../assets/images/media.png";
import {
  PROPERTY_FEATURED_FORM_ID,
  scrollToPropertyFeaturedForm,
} from "./scroll-to-featured-form";

import "./styles.css";

const features = [
  {
    id: 1,
    icon: "fa-solid fa-camera",
    title: "In-house Media Team",
    description:
      "No outsourcing. Our professionals handle everything end-to-end.",
  },
  {
    id: 2,
    icon: "fa-solid fa-chart-line",
    title: "Targeted Distribution",
    description:
      "Your property lands in front of buyers and tenants actively searching.",
  },
  {
    id: 3,
    icon: "fa-solid fa-shield",
    title: "KYC-Verified Inquiries",
    description:
      "Every person who contacts you has been identity-verified by Krent.",
  },
  {
    id: 4,
    icon: "fa-regular fa-location-dot",
    title: "You Stay in Control",
    description:
      "Manage availability, block dates, and own all assets produced.",
  },
];

const PropertyFeaturedSection = () => {
  return (
    <section className="property-featured">
      <div className="property-featured-container">
        <Link to="/" className="property-featured-back font-onest">
          <i className="fa fa-arrow-left" />
          Back to Home
        </Link>

        <div className="property-featured-hero font-onest">
          <div className="property-featured-content font-onest">
            <h2 className="property-featured-title font-onest">
              Get your property seen by the right people
            </h2>

            <p className="property-featured-text font-onest">
              As a property owner, the problem isn&apos;t your property.
              It&apos;s that the right audience isn&apos;t seeing it because you
              don&apos;t have good media assets.
            </p>

            <p className="property-featured-text font-onest">
              Whether you&apos;re trying to sell apartments, lease office
              spaces, fill vacant units, or attract serious buyers, one
              challenge remains the same:
            </p>

            <p className="property-featured-quote font-onest my-4">
              &ldquo;People can&apos;t buy or rent what looks
              unappealing.&rdquo;
            </p>

            <p className="property-featured-accent font-onest my-4">
              Krent changes that.
            </p>

            <p className="property-featured-text font-onest">
              Krent combines professional property videography with targeted
              audience distribution to create demand around your property.
              Instead of simply listing and hoping someone finds it, we actively
              position it in front of the people most likely to buy, rent, or
              invest.
            </p>

            <a
              href={`#${PROPERTY_FEATURED_FORM_ID}`}
              className="property-featured-cta font-onest"
              onClick={scrollToPropertyFeaturedForm}
            >
              Get Your Property Featured
              <i className="fa fa-arrow-right text-white" />
            </a>
          </div>

          <div className="property-featured-media font-onest">
            <img src={media} alt="Property media collage" />
          </div>
        </div>
      </div>

      <div className="property-featured-features">
        <div className="property-featured-container property-featured-features-grid">
          {features.map((feature) => (
            <div
              key={feature.id}
              className="property-featured-feature font-onest"
            >
              <div className="feature-icon-box">
                <i className={feature.icon} />
              </div>
              <div className="feature-content">
                <h5 className="feature-title font-onest">{feature.title}</h5>
                <p className="feature-description font-onest">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PropertyFeaturedSection;
